import React, { useState } from "react";
import useReveal from "./useReveal";

const CONTACTS = [
  {
    icon: "✉",
    label: "Email me",
    href: "mailto:ramakrishnakatragadda1729@gmail.com",
  },
  {
    icon: "in",
    label: "LinkedIn",
    href: "https://linkedin.com/in/ramakrishnakatragadda",
  },
  {
    icon: "gh",
    label: "GitHub",
    href: "https://github.com/ramakrishnakatragadda",
  },
];

const Contact = () => {
  const [infoRef, infoVisible] = useReveal();
  const [formRef, formVisible] = useReveal();
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3500);
  };

  return (
    <section id="contact" className="section-pad-contact" style={s.section}>
      <p style={s.label}>
        <span style={s.slash}>//</span> Contact
      </p>
      <div className="contact-layout">
        <div
          ref={infoRef}
          style={{
            opacity: infoVisible ? 1 : 0,
            transform: infoVisible ? "none" : "translateY(18px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <h3 style={s.heading}>
            Let's build something <em style={s.headingEm}>worth building.</em>
          </h3>
          <p style={s.subtext}>
            If something here resonated with you, feel free to reach out. I'm
            always open to thoughtful conversations about engineering, ideas, or
            even a good cup of tea.
          </p>
          {/* <div style={s.links}>
            {CONTACTS.map((c) => (
              <a
                key={c.label}
                href={c.href}
                target={c.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                style={s.cLink}
              >
                <span style={s.cIcon}>{c.icon}</span>
                <span style={s.cLabel}>{c.label}</span>
              </a>
            ))}
          </div> */}
        </div>

        <div
          ref={formRef}
          style={{
            opacity: formVisible ? 1 : 0,
            transform: formVisible ? "none" : "translateY(18px)",
            transition: "opacity 0.6s ease 0.15s, transform 0.6s ease 0.15s",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div className="contact-form-row">
              <div style={s.field}>
                <label style={s.fieldLabel}>Name</label>
                <input
                  style={s.input}
                  type="text"
                  placeholder="Your name"
                  required
                />
              </div>
              <div style={s.field}>
                <label style={s.fieldLabel}>Email</label>
                <input
                  style={s.input}
                  type="email"
                  placeholder="your@email.com"
                  required
                />
              </div>
            </div>
            <div style={s.field}>
              <label style={s.fieldLabel}>Subject</label>
              <input
                style={s.input}
                type="text"
                placeholder="What's this about?"
              />
            </div>
            <div style={s.field}>
              <label style={s.fieldLabel}>Message</label>
              <textarea
                style={s.textarea}
                placeholder="Tell me what you're thinking..."
                required
              />
            </div>
            <button
              type="submit"
              style={{ ...s.submit, ...(sent ? s.submitSent : {}) }}
            >
              {sent ? "Message sent ✓" : "Send message →"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

const s = {
  section: { maxWidth: 1100, margin: "0 auto" },
  label: {
    fontSize: "0.68rem",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    color: "var(--accent)",
    marginBottom: "2.5rem",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  slash: { color: "var(--muted)" },
  heading: {
    fontFamily: "var(--serif)",
    fontSize: "clamp(1.5rem,3vw,2rem)",
    color: "var(--text)",
    lineHeight: 1.3,
    marginBottom: "1.25rem",
  },
  headingEm: { fontStyle: "italic", color: "var(--accent)" },
  subtext: {
    fontSize: "0.85rem",
    color: "var(--muted2)",
    lineHeight: 1.9,
    marginBottom: "2rem",
  },
  links: { display: "flex", flexDirection: "column", gap: "0.5rem" },
  cLink: {
    display: "flex",
    alignItems: "center",
    gap: "0.85rem",
    textDecoration: "none",
    padding: "0.5rem 0",
  },
  cIcon: {
    width: 36,
    height: 36,
    border: "1px solid var(--border2)",
    borderRadius: 4,
    background: "var(--bg2)",
    color: "var(--muted2)",
    fontSize: "0.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontFamily: "var(--mono)",
  },
  cLabel: {
    fontSize: "0.85rem",
    color: "var(--muted2)",
    fontFamily: "var(--mono)",
    letterSpacing: "0.04em",
  },
  field: { marginBottom: "1rem" },
  fieldLabel: {
    display: "block",
    fontSize: "0.65rem",
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: "var(--muted)",
    marginBottom: "0.5rem",
  },
  input: {
    width: "100%",
    background: "var(--bg2)",
    border: "1px solid var(--border2)",
    borderRadius: "var(--radius)",
    padding: "10px 14px",
    fontFamily: "var(--mono)",
    fontSize: "0.82rem",
    color: "var(--text)",
    outline: "none",
  },
  textarea: {
    width: "100%",
    background: "var(--bg2)",
    border: "1px solid var(--border2)",
    borderRadius: "var(--radius)",
    padding: "10px 14px",
    fontFamily: "var(--mono)",
    fontSize: "0.82rem",
    color: "var(--text)",
    outline: "none",
    resize: "none",
    minHeight: 130,
  },
  submit: {
    width: "100%",
    fontFamily: "var(--mono)",
    fontSize: "0.75rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    background: "var(--accent3)",
    color: "#fff",
    border: "none",
    padding: 13,
    borderRadius: "var(--radius)",
    cursor: "pointer",
    transition: "opacity 0.2s, background 0.3s",
  },
  submitSent: { background: "#166534" },
};

export default Contact;
